import React from 'react';

const Services = () => {
    const services = [
        {
            id: 1,
            class: 'architectural',
            icon: 'fas fa-drafting-compass',
            title: 'Architectural Consulting',
            description: 'Expert architectural design and planning services for residential, commercial, and industrial projects. From concept to completion, we ensure innovative and functional designs.'
        },
        {
            id: 2,
            class: 'construction',
            icon: 'fas fa-hard-hat',
            title: 'Contracting And Management',
            description: 'Full-service construction management from foundation to finishing with quality assurance. '
        },
        {
            id: 3,
            class: 'stilt-house',
            icon: 'fas fa-home',
            title: 'Stilt Houses',
            description: 'Specialized in designing and constructing stilt houses and prefabricated modular villas on a turnkey contract basis. '
        },
        {
            id: 4,
            class: 'interiors-management',
            icon: 'fas fa-couch',
            title: 'Interiors & Management',
            description: 'Complete interior design solutions and project management services.'
        }
    ];

    return (
        <section className="services" id="services">
            <div className="container">
                <div className="section-title">
                    <h2> Services</h2>
                    <p>We offer a wide range of services to help bring your architectural vision to life</p>
                </div>
                <div className="services-grid">
                    {services.map(service => (
                        <div key={service.id} className={`service-card ${service.class}`}>
                            <div className="service-image"></div>
                            <div className="service-icon">
                                <i className={service.icon}></i>
                            </div>
                            <div className="service-content">
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;